var React = require('react');

function MaskFeature (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"m833.2 796.6-2.3 1.5-1.8 1.2c-111.2 73.5-234.9 108.3-379.6 86-3-.4-2.8-4.8.2-5a913 913 0 0 0 75.7-8.9 311.3 311.3 0 0 0 71.6-21c8.6-3.5 18.3-8.5 27.6-16.1 9.7-8.1 12.4-25.3-3.4-26.4-24.1-1.8-38.5 15-79.2 30.2-81.5 30.3-201.4 36.1-354.4-63.8a627.7 627.7 0 0 1-85.7-81c-2.4-2.7-98.3-13.5-98.3-16.6 0-89.4-8.1-328.3 0-425 4.8-56.5 0-212.6 9-244 7.2-24.8 595.4 19.8 659 4.6 59.3-14.2 117 8 126.5 11.1 56.2 18.8 102 52.6 141.5 100 23-26 48.8 3.2 70.8 34.6 21.1 30.4 30 69.8 30 69.8C1115 510.2 914 723.5 914 723.5a378.2 378.2 0 0 1-80.8 73.1Z","id":"a-mask"})),React.createElement("use",{"fill":"#79C9DA","transform":"matrix(-1 0 0 1 1057 -298)","xlinkHref":"#a-mask","fillRule":"evenodd","key":1})]);
}

MaskFeature.defaultProps = {"viewBox":"0 0 859 594"};

module.exports = MaskFeature;

MaskFeature.default = MaskFeature;
